import {
  formatOccupantsShort,
  formatTourTravellers,
} from 'lib/offer/occupancyUtils'
import { useOrder } from 'tripPlanner/hooks/api'
import { TourItem } from 'tripPlanner/types/tripItem'
import { getOrderId } from 'tripPlanner/utils'

export default function useTourV2ItemOccupancyDescription(
  item: TourItem,
): string | undefined {
  const orderId = getOrderId(item)

  const { data: order } = useOrder(orderId)

  if (orderId) {
    // This is an LE tour booking
    if (order) {
      const travellers = order.tourItems
        .filter(
          (orderItem) =>
            orderItem.tourId === item.code && orderItem.tour.travellers,
        )
        .flatMap((orderItem) => orderItem.tour.travellers)
      if (travellers.length > 0) {
        return formatTourTravellers(travellers)
      }
    }
  } else if (item.savedItemData?.occupancies) {
    // This is a bookmark
    return formatOccupantsShort(item.savedItemData.occupancies)
  }
}
